import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Home from './components/Home.vue'
import Impressum from './components/Impressum.vue'
import Router from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import VueMeta from "vue-meta";

// styles
import './assets/styles/app.scss'

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMeta)

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -100,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.config.productionTip = false

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes:[
      {
        path: '/',
        name: 'home',
        component: Home,
      },
      {
        path:'/impressum',
        name:'impressum',
        component: Impressum,
      },
  ]
})

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
